import { Model } from './model';

export class CallAgentScenario extends Model {
  id: string;

  response: string;

  scenario: string;
}
